
export default {
  name: "Loader"
};
